import { CommonEnums } from '../../common.enums';
import { Looper_End } from './looper_end';

export class LoopEnd {
    looper_End: Looper_End;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.looper_End = new Looper_End();
    }

    static parse(loopEndTmp: LoopEnd): LoopEnd {
        let loopEnd: LoopEnd = new LoopEnd();
        loopEnd.copyFrom(loopEndTmp);
        return loopEnd;
    }

    copy(): LoopEnd {
        let loopEndTmp: LoopEnd = new LoopEnd();

        loopEndTmp.looper_End = this.looper_End.copy();
        loopEndTmp.change_Ind = this.change_Ind;
        loopEndTmp.error_Cd = this.error_Cd;
        loopEndTmp.error_Msg = this.error_Msg;
        loopEndTmp.ref_Id = this.ref_Id;
        loopEndTmp.ref_Cd = this.ref_Cd;
        loopEndTmp.fldr_Id = this.fldr_Id;

        return loopEndTmp;
    }

    copyFrom(loopEndTmp: LoopEnd): void {
        this.looper_End.copyFrom(loopEndTmp.looper_End);
        this.change_Ind = loopEndTmp.change_Ind;
        this.error_Cd = loopEndTmp.error_Cd;
        this.error_Msg = loopEndTmp.error_Msg;
        this.ref_Id = loopEndTmp.ref_Id;
        this.ref_Cd = loopEndTmp.ref_Cd;
        this.fldr_Id = loopEndTmp.fldr_Id;
    }

    compare(loopEndTmp: LoopEnd): string {
        let diffString: string = this.looper_End.compare(loopEndTmp.looper_End);
        if (diffString != '') return diffString;

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "LoopEnd [looper_End  =" + this.looper_End.toString();

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", ref_Id=" + this.ref_Id + ", ref_Cd=" + this.ref_Cd + ", fldr_Id=" + this.fldr_Id;
        }

        str += "]";
        return str;
    }
}